'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const TrustScoreInner = dynamic(() => import('./TrustScoreInner'), { ssr: false });

export default function TrustScorePanel() {
  return (
    <div
      className="rounded-2xl p-6 shadow-card h-full"
      style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
    >
      <h3 className="text-base font-semibold mb-1">Ecosystem Trust Score</h3>
      <p className="text-xs mb-4" style={{ color: 'var(--muted-foreground)' }}>
        Overall platform confidence rating
      </p>
      <TrustScoreInner />
      <div className="mt-4 space-y-3">
        {[
          { label: 'Certificate Validity', score: 96, color: 'var(--emerald-bright)' },
          { label: 'Business Verification', score: 91, color: 'var(--gold)' },
          { label: 'Compliance Readiness', score: 88, color: 'var(--info)' },
          { label: 'Audit Trail Completeness', score: 94, color: '#A855F7' },
          { label: 'Shariah Review Status', score: 87, color: 'var(--warning)' },
        ]?.map((item) => (
          <div key={`trust-${item?.label}`}>
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs" style={{ color: 'var(--muted-foreground)' }}>{item?.label}</span>
              <span className="text-xs font-semibold font-mono-data" style={{ color: item?.color }}>{item?.score}%</span>
            </div>
            <div className="w-full h-1.5 rounded-full" style={{ background: 'var(--muted)' }}>
              <div
                className="h-1.5 rounded-full transition-all duration-500"
                style={{ width: `${item?.score}%`, background: item?.color }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}